export const PATIENT_ACTIVITY_LOG_DEFAULT_SORT = {
  sortedColumn: 'startTime',
  sortedColumnOrder: 'descend'
}

export const INTERNAL_NOTE_FILTER = [
  {
    key: 0,
    value: null,
    title: 'All'
  },
  {
    key: 1,
    value: 1,
    title: 'Only Internal Notes'
  },
  {
    key: 2,
    value: 0,
    title: 'Exclude Internal Notes'
  }
]

export const TYPE_CODES = [
  {
    key: 0,
    value: null,
    title: 'All'
  },
  {
    key: 1,
    value: 1,
    title: 'System'
  },
  {
    key: 2,
    value: 2,
    title: 'Manual'
  }
]

export const BILLABLE_FILTER = [
  {
    key: 0,
    label: 'All',
    title: 'All',
    value: null
  },
  {
    key: 1,
    label: 'Billable',
    title: 'Billable',
    value: 1
  },
  {
    key: 2,
    label: 'Non-billable',
    title: 'Non-billable',
    value: 2
  }
]

export const INTERVENTIONS_FILTER = [
  {
    key: 0,
    value: null,
    label: 'All',
    title: 'All'
  },
  {
    key: 1,
    value: 1,
    label: 'With intervention',
    title: 'With intervention'
  },
  {
    key: 2,
    value: 0,
    label: 'Without intervention',
    title: 'Without intervention'
  }
]
